module.exports = __webpack_public_path__ + "img/P150T_weapon_82.4831b271.png";